import { request } from '@/common/services/request';

export async function updateCurrentUser(data) {
  return request('/auth/update-user', {
    method: 'POST',
    data,
  });
}
